
import React from 'react';
import { Link } from 'react-router-dom';

const CustomerUploadGuide = () => {
  return (
    <div className="bg-white p-8 w-full max-w-4xl mx-auto my-8 shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-gray-200">
        使い方 - 顧客CSVアップロード
      </h1>
      <p className="text-lg text-gray-800 mb-6">
        顧客CSVアップロードではCSVファイルを読み込ませることでStripeへの顧客登録ができます。
      </p>

      <hr className="my-8 border-gray-200" />

      {/* Section 1: Preparation */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. 利用の準備</h2>
        <p className="mb-4 text-gray-700">
          本機能の利用には<a href="https://stripe.com/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Stripe</a>のアカウントが必要です。<br />
          ※Stripeのアカウントをお持ちでない方はアカウントを作成してください。
        </p>
      </section>

      <hr className="my-8 border-gray-200" />

      {/* Section 2: CSV Creation */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. CSV作成方法</h2>
        <p className="mb-4 text-gray-700">
          CSVファイルのフォーマットをダウンロードしてください。<br />
          CSVファイルのフォーマットに顧客情報を入力します。<br />
          CSVファイルの項目と入力値については「サポート」の<Link to="/app/support/csv-format" className="text-blue-600 hover:underline">「CSVフォーマット」</Link>を確認してください。
        </p>
      </section>

      <hr className="my-8 border-gray-200" />

      {/* Section 3: CSV Upload */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. CSVアップロード方法</h2>
        <p className="mb-4 text-gray-700">
          作成したCSVファイルを選択、もしくはドラッグアンドドロップします。<br />
          準備ができたら「アップロード」ボタンを押してください。<br />
          エラーが出た場合、CSVファイルに入力した値に不備があります。<br />
          エラー内容をもとに入力した値を修正してください。
        </p>
      </section>
      
      <hr className="my-8 border-gray-200" />

      {/* Section 4: Confirmation */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. 作成された顧客の確認方法</h2>
        <p className="mb-4 text-gray-700">
          アップロードの結果はCSVファイルでダウンロードできます。<br />
          ダウンロードしたファイルには登録した情報とともにStripeのカスタマーIDが記載されています。<br />
          実際に作成された顧客はstripeのダッシュボードでも確認できます。
        </p>
      </section>

      <div className="mt-8 text-center">
        <Link 
          to="/app/support/how-to-use"
          className="inline-block bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-6 rounded-lg transition-colors"
        >
          「使い方」一覧へ戻る
        </Link>
      </div>

    </div>
  );
};

export default CustomerUploadGuide;
